import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const UpdateDualFormStatusModal = ({
  isShown,
  isUpdatingDualFormStatus,
  onConfirmUpdate,
  onCancel,
  updateDualFormStatusError,
  checkStatus,
  accountNumber
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title={ checkStatus === true ? `Enable Dual Form Requirement - ${ accountNumber }` : `Disable Dual Form Requirement - ${ accountNumber }` }
    btnConfirmTitle="Confirm"
    btnConfirmClass={ `btn-danger ${ isUpdatingDualFormStatus ? 'loading' : '' }` }
    btnCancelTitle="Cancel"
    onConfirm={ onConfirmUpdate }
    onCancel={ onCancel }
  >
    <p>
      { checkStatus === true
        ? 'By enabling the dual form requirement, the account certification status will be based upon validation of both applicable workflow complete valid forms.'
        : 'By disabling the dual form requirement, the account certification status will be based upon the most recently signed workflow complete valid form.' }
    </p>
    {
      updateDualFormStatusError
      && <div className="toast toast-error">
        { updateDualFormStatusError }
      </div>
    }
  </ModalWrapper>
);

UpdateDualFormStatusModal.propTypes = {
  isShown: PropTypes.bool,
  isUpdatingDualFormStatus: PropTypes.bool,
  onConfirmUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  updateDualFormStatusError: PropTypes.string,
  checkStatus: PropTypes.bool.isRequired,
  accountNumber: PropTypes.string
};

UpdateDualFormStatusModal.defaultProps = {
  isShown: false,
  isUpdatingDualFormStatus: false,
  updateDualFormStatusError: null,
  accountNumber: ''
};

export default UpdateDualFormStatusModal;
